import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { DashboardPage } from "@/features/dashboard/dashboard-page";

export const Route = createFileRoute("/_authenticated/$orgSlug/")({
  validateSearch: z.object({
    billing: z.enum(["inactive"]).optional(),
    cmdk: z.literal("1").optional(),
    modal: z
      .enum(["org_settings", "user_settings", "project_settings"])
      .optional(),
  }),
  component: DashboardPage,
});
